// extracted by mini-css-extract-plugin
var _1 = "PersonalSurvey_description__H-f0o";
var _2 = "PersonalSurvey_header__wc0hd";
var _3 = "PersonalSurvey_hiddenDesktop__1kBSE";
var _4 = "PersonalSurvey_hiddenMobile__jQk9w";
var _5 = "768px";
var _6 = "\"../shared.module.css\"";
var _7 = "PersonalSurvey_subheader__HWd1X";
export { _1 as "description", _2 as "header", _3 as "hiddenDesktop", _4 as "hiddenMobile", _5 as "md", _6 as "shared", _7 as "subheader" }
